import { ReactNode } from 'react';
import BgNsLockup from '@britishgasenergy/react-nucleus/dist/nuc-components/NsLockup';
import NsImage from '@britishgasenergy/react-nucleus/dist/nuc-components/NsImage';

type NsLockupProps = {
  type?: 'lockbox' | 'locknut' | 'lockjaw';
  reverse?: boolean;
  ratio?: '16x9' | '4x3' | '1x1';
  decoration?: 
    | 'appliance'
    | 'applianceCover'
    | 'applianceRepair'
    | 'boiler'
    | 'boilerCover'
    | 'boilerRepair'
    | 'bulb'
    | 'calendar'
    | 'centralHeating'
    | 'chat'
    | 'clock'
    | 'compass'
    | 'cosmo'
    | 'document'
    | 'dualFuel'
    | 'electricChargingStation'
    | 'electricVehicle'
    | 'electrics'
    | 'engineer'
    | 'fix'
    | 'fixedSA'
    | 'gas'
    | 'greenLeaf'
    | 'help'
    | 'home'
    | 'homeInsurance'
    | 'laptop'
    | 'low-carbon'
    | 'multiple-people'
    | 'oven'
    | 'phone'
    | 'pipeAndDrain'
    | 'protect'
    | 'radiator'
    | 'savings'
    | 'settings'
    | 'sms'
    | 'tap'
    | 'track-engineer'
    | 'van'
    | 'warning'
    | 'whatsApp'
    | 'yellowShield'
    | 'error'
    | 'success'
    | 'info';
  image?: string;
  heading?: ReactNode;
  subHeading?: ReactNode;
  action?: ReactNode; 
  children?: ReactNode;
};

export const NsLockup = ({
  reverse,
  ratio = '4x3',
  decoration,
  image,
  heading,
  subHeading,
  action,
  children
}: NsLockupProps) => {
  const hasHeadings = heading || subHeading;

  return (
    <BgNsLockup reverse={reverse} decoration={decoration}>
      {hasHeadings && (
        <h2 slot="heading">
          {subHeading && <span className="h5">{subHeading}</span>}
          {heading && <span className="h1">{heading}</span>}
        </h2>
      )}
      <div slot="paragraph">{children}</div>
      {action && <div slot="cta">{action}</div>}
      <NsImage slot="image" ratio={ratio} src={image} />
    </BgNsLockup>
  );
};
